import React from "react";
import TestsPageTemplate from "../components/TestsPageTemplate";
import {TEST_TYPES} from "../../../../shared/types/testTypes";

const TestsTraining = () => {

    return (
        <TestsPageTemplate
            config={TEST_TYPES.training}
        />
    );
};

export default TestsTraining;
